/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type AdVehicleStreamServiceCancellationStateSubscriptionVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['String']['input']
  }>

export type AdVehicleStreamServiceCancellationStateSubscription = {
  __typename?: 'Subscription'
  fccServiceCancellationState: {
    __typename?: 'FccServiceCancellationState'
    vehicleId: string
    cancellationType: Types.FccServiceCancellationTypeEnum | null
    state: Types.FccServiceCancellationStateEnum | null
    trips: Array<{
      __typename?: 'FccServiceCancellationTrip'
      isBoarded: boolean
      passengerAuthenticationStatus: Types.FccServiceCancellationPassengerAuthenticationStatusEnum
      tripId: string
    }> | null
    cancellationError: {
      __typename?: 'FccServiceCancellationError'
      code: Types.FccServiceCancellationErrorCode
    } | null
  }
}

export const AdVehicleStreamServiceCancellationStateDocument = gql`
    subscription AdVehicleStreamServiceCancellationState($vehicleId: String!) {
  fccServiceCancellationState(vehicleId: $vehicleId) {
    vehicleId
    cancellationType
    state
    trips {
      isBoarded
      passengerAuthenticationStatus
      tripId
    }
    cancellationError {
      code
    }
  }
}
    `

/**
 * __useAdVehicleStreamServiceCancellationStateSubscription__
 *
 * To run a query within a React component, call `useAdVehicleStreamServiceCancellationStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamServiceCancellationStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamServiceCancellationStateSubscription({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamServiceCancellationStateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AdVehicleStreamServiceCancellationStateSubscription,
    AdVehicleStreamServiceCancellationStateSubscriptionVariables
  > &
    (
      | {
          variables: AdVehicleStreamServiceCancellationStateSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    AdVehicleStreamServiceCancellationStateSubscription,
    AdVehicleStreamServiceCancellationStateSubscriptionVariables
  >(AdVehicleStreamServiceCancellationStateDocument, options)
}
export type AdVehicleStreamServiceCancellationStateSubscriptionHookResult =
  ReturnType<typeof useAdVehicleStreamServiceCancellationStateSubscription>
export type AdVehicleStreamServiceCancellationStateSubscriptionResult =
  Apollo.SubscriptionResult<AdVehicleStreamServiceCancellationStateSubscription>
